/* eslint-disable */
import { mapGetters, mapMutations } from 'vuex';
import riskCalculations from "./riskCalculations";
export default {
  mixins: [riskCalculations],
  data() {
    return {
    	calcsConst: {
	    MALE: 'Male',
	    FEMALE: 'Female',
      METRIC: 'metricSystem',
      STANDARD: 'englishSystem'
    	},
    }
  },
  
  computed: {
    ...mapGetters('userData', ['userData']),
  },
    
  methods: {
    ...mapMutations('userData', ['saveCalculations', 'saveConfInt']),
    
    // BMI calculation.
    bmi: function (centimeters, kilograms) {
      return kilograms / Math.pow(centimeters / 100, 2);
    },
      
    // INCHES to CM convertion
    inchesToCm: function (inches) {
      return inches * 2.54;
    },

    // CM to INCHES convertion
    cmToInches: function (cms) {
      return cms * 0.393701;
    },
    
    // LB to KG convertion
    lbsToKg: function (lbs) {
      return lbs * 0.45359237;
    },
    
    // KG to LB convertion
    kgToLbs: function (kgs) {
      return kgs * 2.20462;
    },
    
    // YLL calculation
    getYll: function(bmi) {
      return ( ((-1.072898) + (-0.0834375) * 45 + 0.2415805 * bmi));
    },
     
    // percentWeight calculation.
    percentWeight: function (weight, percentage) {
      return (weight - (weight * percentage/100));
    },
    
    weightPercCalculator: function(weight, height, bmi, units) {
      // lb loss = SUM(2.2*bmi loss)*((in*0.0254)^2)
      var bmiLoss = [2.7, 5.7];
      // chk units and convert to lbs and in
      if (this.userData.unitsSystem === this.calcsConst.METRIC) {
        height = this.cmToInches(height);
        weight = this.kgToLbs(weight);
      }
      var lbLoss = [(2.2 * bmiLoss[0]) * (height * 0.0254) * (height * 0.0254), (2.2 * bmiLoss[1]) * (height * 0.0254) * (height * 0.0254)];
      var weightLoss = [weight - lbLoss[0], weight - lbLoss[1]];
      var weightLossPerc = [Math.round(lbLoss[0] / weight * 100), Math.round(lbLoss[1] / weight * 100)];
      if (this.userData.unitsSystem === this.calcsConst.METRIC) {
        weightLoss = [this.lbsToKg(weightLoss[0]), this.lbsToKg(weightLoss[1])];
      }
      return [weightLossPerc, weightLoss];
    },
      
    // updates bmi and weight values
    updateBmi: function(isValid) {
      // calculate values if data is valid
      if (isValid) {
        var bmi;
        var weight = this.userData.weight;
        var adjWeight= { adj5: '', adj10: '', adj15: '', adj20: ''};
        var adjBMI= { adj5: '', adj10: '', adj15: '', adj20: ''};
        var height = this.userData.height;

        if (this.userData.unitsSystem === this.calcsConst.STANDARD) {
          height = this.inchesToCm(this.userData.height);
          weight = this.lbsToKg(this.userData.weight);
        }

        bmi = this.bmi(height, weight);
        this.userData.bmi = Math.round(bmi);
            
          // precalculate adjusted weight 
          adjWeight= { 
            adj5: Math.round(this.percentWeight(this.userData.weight, 5)), 
            adj10: Math.round(this.percentWeight(this.userData.weight, 10)), 
            adj15: Math.round(this.percentWeight(this.userData.weight, 15)), 
            adj20: Math.round(this.percentWeight(this.userData.weight, 20))
          };
          
          // precalculate adjusted BMI
          adjBMI= { 
            adj5: Math.round(this.bmi(height, (this.userData.unitsSystem === this.calcsConst.STANDARD) ? this.lbsToKg(adjWeight.adj5) : adjWeight.adj5)),
            adj10: Math.round(this.bmi(height, (this.userData.unitsSystem === this.calcsConst.STANDARD) ? this.lbsToKg(adjWeight.adj10) : adjWeight.adj10)),
            adj15: Math.round(this.bmi(height, (this.userData.unitsSystem === this.calcsConst.STANDARD) ? this.lbsToKg(adjWeight.adj15) : adjWeight.adj15)),
            adj20: Math.round(this.bmi(height, (this.userData.unitsSystem === this.calcsConst.STANDARD) ? this.lbsToKg(adjWeight.adj20) : adjWeight.adj20))
          }
      }
      // else reset values
      else {
        this.userData.bmi = '' ;
        adjWeight= { adj5: '', adj10: '', adj15: '', adj20: ''};
        adjBMI= { adj5: '', adj10: '', adj15: '', adj20: ''};
      }
      this.saveCalculations({data:adjWeight, section: 'weight'});
      this.saveCalculations({data:adjBMI, section: 'bmi'});
      
    },

    updateRisk: function(isValid) { 
      // Risk value calculations
      // var lower = upper =  0;
      if (isValid) {
        //Cancer
        var cancerCalc = 
        { current: Math.round(this.cancerRisk(this.userData.bmi > 50 ? 50 : (this.userData.bmi < 20 ? 20:this.userData.bmi)) * 1000)/1000, 
          adj5: Math.round(this.cancerRisk(this.userData.calc.bmi.adj5 > 50 ? 50 : (this.userData.calc.bmi.adj5 < 20 ? 20: this.userData.calc.bmi.adj5)) * 1000)/1000, 
          adj10: Math.round(this.cancerRisk(this.userData.calc.bmi.adj10 > 50 ? 50 : (this.userData.calc.bmi.adj10 < 20 ? 20: this.userData.calc.bmi.adj10)) * 1000)/1000, 
          adj15: Math.round(this.cancerRisk(this.userData.calc.bmi.adj15 > 50 ? 50 : (this.userData.calc.bmi.adj15 < 20 ? 20: this.userData.calc.bmi.adj15)) * 1000)/1000,  
          adj20: Math.round(this.cancerRisk(this.userData.calc.bmi.adj20 > 50 ? 50 : (this.userData.calc.bmi.adj20 < 20 ? 20: this.userData.calc.bmi.adj20)) * 1000)/1000, 
        };
        
        this.saveCalculations({data:
        { current: Math.round(this.cancerRisk(this.userData.bmi > 50 ? 50 : (this.userData.bmi < 20 ? 20:this.userData.bmi)) * 100)/100, 
          adj5: Math.round(this.cancerRisk(this.userData.calc.bmi.adj5 > 50 ? 50 : (this.userData.calc.bmi.adj5 < 20 ? 20: this.userData.calc.bmi.adj5)) * 100)/100, 
          adj10: Math.round(this.cancerRisk(this.userData.calc.bmi.adj10 > 50 ? 50 : (this.userData.calc.bmi.adj10 < 20 ? 20: this.userData.calc.bmi.adj10)) * 100)/100, 
          adj15: Math.round(this.cancerRisk(this.userData.calc.bmi.adj15 > 50 ? 50 : (this.userData.calc.bmi.adj15 < 20 ? 20: this.userData.calc.bmi.adj15)) * 100)/100,  
          adj20: Math.round(this.cancerRisk(this.userData.calc.bmi.adj20 > 50 ? 50 : (this.userData.calc.bmi.adj20 < 20 ? 20: this.userData.calc.bmi.adj20)) * 100)/100, 
        }, section: 'cancer'});
        
        this.saveConfInt({data:
        { current: [ Math.round( (Math.round( (cancerCalc.current-(1.96*0.0330321) )* 1000)/1000 ) *100)/100 , Math.round( (Math.round((cancerCalc.current+(1.96*0.0330321)) * 1000)/1000 ) *100)/100], 
          adj5: [Math.round( (Math.round( (cancerCalc.adj5-(1.96*0.0330321) )* 1000)/1000 ) *100)/100, Math.round( (Math.round( (cancerCalc.adj5+(1.96*0.0330321) )* 1000)/1000 ) *100)/100], 
          adj10: [Math.round( (Math.round((cancerCalc.adj10-(1.96*0.0330321))* 1000)/1000 ) *100)/100, Math.round( (Math.round((cancerCalc.adj10+(1.96*0.0330321))* 1000)/1000 ) *100)/100], 
          adj15: [Math.round( (Math.round((cancerCalc.adj15-(1.96*0.0330321))* 1000)/1000 ) *100)/100, Math.round( (Math.round((cancerCalc.adj15+(1.96*0.0330321))* 1000)/1000 ) *100)/100],  
          adj20: [Math.round( (Math.round((cancerCalc.adj20-(1.96*0.0330321))* 1000)/1000 ) *100)/100, Math.round( (Math.round((cancerCalc.adj20+(1.96*0.0330321))* 1000)/1000 ) *100)/100], 
        }, section: 'cancer'});
        // console.log('in cancer risk calculator: '+JSON.stringify(this.userData.calc.cancer));
        // console.log('in cancer conf calculator: '+JSON.stringify(this.userData.confInt.cancer));
        
        // Dyslipidemia
        var dyslipCalc = 
        { current: Math.round(this.hlpRisk(this.userData.bmi > 40 ? 40 : (this.userData.bmi < 20?20:this.userData.bmi))* 100000)/1000, 
          adj5: Math.round(this.hlpRisk(this.userData.calc.bmi.adj5 > 40 ? 40 : (this.userData.calc.bmi.adj5 < 20?20:this.userData.calc.bmi.adj5))* 100000)/1000, 
          adj10: Math.round(this.hlpRisk(this.userData.calc.bmi.adj10 > 40 ? 40 : (this.userData.calc.bmi.adj10 < 20?20: this.userData.calc.bmi.adj10))* 100000)/1000, 
          adj15: Math.round(this.hlpRisk(this.userData.calc.bmi.adj15 > 40 ? 40 : (this.userData.calc.bmi.adj15 < 20?20: this.userData.calc.bmi.adj15))* 100000)/1000,  
          adj20: Math.round(this.hlpRisk(this.userData.calc.bmi.adj20 > 40 ? 40 : (this.userData.calc.bmi.adj20 < 20?20: this.userData.calc.bmi.adj20))* 100000)/1000, 
        };
        
        this.saveCalculations({data:
        { current: Math.round(this.hlpRisk(this.userData.bmi > 40 ? 40 : (this.userData.bmi < 20?20:this.userData.bmi))* 1000)/10, 
          adj5: Math.round(this.hlpRisk(this.userData.calc.bmi.adj5 > 40 ? 40 : (this.userData.calc.bmi.adj5 < 20?20:this.userData.calc.bmi.adj5))* 1000)/10, 
          adj10: Math.round(this.hlpRisk(this.userData.calc.bmi.adj10 > 40 ? 40 : (this.userData.calc.bmi.adj10 < 20?20: this.userData.calc.bmi.adj10))* 1000)/10, 
          adj15: Math.round(this.hlpRisk(this.userData.calc.bmi.adj15 > 40 ? 40 : (this.userData.calc.bmi.adj15 < 20?20: this.userData.calc.bmi.adj15))* 1000)/10,  
          adj20: Math.round(this.hlpRisk(this.userData.calc.bmi.adj20 > 40 ? 40 : (this.userData.calc.bmi.adj20 < 20?20: this.userData.calc.bmi.adj20))* 1000)/10, 
        }, section: 'dyslip'});
        
        this.saveConfInt({data:
        { current: [Math.max(0, (Math.round( (Math.round( (dyslipCalc.current-(1.96*6.2004))*100)/100 )*10)/10)) , Math.min(100, (Math.round( (Math.floor( ((dyslipCalc.current+(1.96*6.2004))/100) *10000) /100)*10 )/10))], 
          adj5: [Math.max(0, (Math.round( (Math.round((dyslipCalc.adj5-(1.96*6.2004))*100)/100 )*10)/10)), Math.min(100, (Math.round( (Math.floor( ((dyslipCalc.adj5+(1.96*6.2004))/100) *10000) /100)*10 )/10))], 
          adj10: [Math.max(0, (Math.round( (Math.round((dyslipCalc.adj10-(1.96*6.2004))*100)/100 )*10)/10)), Math.min(100, (Math.round( (Math.floor( ((dyslipCalc.adj10+(1.96*6.2004))/100) *10000) /100)*10 )/10))], 
          adj15: [Math.max(0, (Math.round( (Math.round((dyslipCalc.adj15-(1.96*6.2004))*100)/100 )*10)/10)), Math.min(100, (Math.round( (Math.floor( ((dyslipCalc.adj15+(1.96*6.2004))/100) *10000) /100)*10 )/10))],  
          adj20: [Math.max(0, (Math.round( (Math.round((dyslipCalc.adj20-(1.96*6.2004))*100)/100 )*10)/10)), Math.min(100, (Math.round( (Math.floor( ((dyslipCalc.adj20+(1.96*6.2004))/100) *10000) /100)*10 )/10))], 
        }, section: 'dyslip'});
        // console.log('in calc manager: dyslip risk: '+JSON.stringify(this.userData.calc.dyslip));
        
        //Hypertension
        var hypCalc = 
        { current: (this.htnRisk(this.userData.bmi > 40 ? 40 :(this.userData.bmi < 20?20:this.userData.bmi) ) * 100), 
          adj5: (this.htnRisk(this.userData.calc.bmi.adj5 > 40 ? 40 :(this.userData.calc.bmi.adj5 < 20?20:this.userData.calc.bmi.adj5) ) * 100), 
          adj10:(this.htnRisk(this.userData.calc.bmi.adj10 > 40 ? 40 :(this.userData.calc.bmi.adj10 < 20?20: this.userData.calc.bmi.adj10)) * 100), 
          adj15: (this.htnRisk(this.userData.calc.bmi.adj15 > 40 ? 40 :(this.userData.calc.bmi.adj15 < 20?20: this.userData.calc.bmi.adj15)) * 100),  
          adj20: (this.htnRisk(this.userData.calc.bmi.adj20 > 40 ? 40 :(this.userData.calc.bmi.adj20 < 20?20: this.userData.calc.bmi.adj20)) * 100), 
        };
        
        this.saveCalculations({data:
        { current: Math.round(this.htnRisk(this.userData.bmi > 40 ? 40 :(this.userData.bmi < 20?20:this.userData.bmi) ) * 100), 
          adj5: Math.round(this.htnRisk(this.userData.calc.bmi.adj5 > 40 ? 40 :(this.userData.calc.bmi.adj5 < 20?20:this.userData.calc.bmi.adj5) ) * 100), 
          adj10: Math.round(this.htnRisk(this.userData.calc.bmi.adj10 > 40 ? 40 :(this.userData.calc.bmi.adj10 < 20?20: this.userData.calc.bmi.adj10)) * 100), 
          adj15: Math.round(this.htnRisk(this.userData.calc.bmi.adj15 > 40 ? 40 :(this.userData.calc.bmi.adj15 < 20?20: this.userData.calc.bmi.adj15)) * 100),  
          adj20: Math.round(this.htnRisk(this.userData.calc.bmi.adj20 > 40 ? 40 :(this.userData.calc.bmi.adj20 < 20?20: this.userData.calc.bmi.adj20)) * 100), 
        }, section: 'hypten'});
        
        this.saveConfInt({data:
        { current: [Math.round(  (Math.max(0, (hypCalc.current-(1.96*0.002696722*100)) ) ) ) , Math.min(100, (Math.round( ((hypCalc.current+((1.96*0.002696722)*100)) )) ))],
          adj5: [Math.round(  (Math.max(0, (hypCalc.adj5-(1.96*0.002696722*100)) ) ) ), Math.min(100, (Math.round( (hypCalc.adj5+((1.96*0.002696722)*100)) ) ))],
          adj10: [Math.round(  (Math.max(0, (hypCalc.adj10-(1.96*0.002696722*100)) ) )), Math.min(100, (Math.round( ((hypCalc.adj10+((1.96*0.002696722)*100)) )) ))],
          adj15: [Math.round(  (Math.max(0, (hypCalc.adj15-(1.96*0.002696722*100)) ) ) ), Math.min(100, (Math.round( ((hypCalc.adj15+((1.96*0.002696722)*100)) )) ))], 
          adj20: [Math.round(  (Math.max(0, (hypCalc.adj20-(1.96*0.002696722*100)) ) ) ),Math.min(100, (Math.round( ((hypCalc.adj20+((1.96*0.002696722)*100)) )) ))],
        }, section: 'hypten'});
        
        // pcos
        var pcosCalc = 
         { current: Math.round(this.pcosRisk(this.userData.bmi > 40 ? 40 : (this.userData.bmi < 20?20:this.userData.bmi) ) * 1000)/1000, 
          adj5: Math.round(this.pcosRisk(this.userData.calc.bmi.adj5 > 40 ? 40 : (this.userData.calc.bmi.adj5 < 20?20:this.userData.calc.bmi.adj5)) * 1000)/1000, 
          adj10: Math.round(this.pcosRisk(this.userData.calc.bmi.adj10 > 40 ? 40 : (this.userData.calc.bmi.adj10 < 20?20: this.userData.calc.bmi.adj10)) * 1000)/1000, 
          adj15: Math.round(this.pcosRisk(this.userData.calc.bmi.adj15 > 40 ? 40 : (this.userData.calc.bmi.adj15 < 20?20: this.userData.calc.bmi.adj15)) * 1000)/1000, 
          adj20: Math.round(this.pcosRisk(this.userData.calc.bmi.adj20 > 40 ? 40 : (this.userData.calc.bmi.adj20 < 20?20: this.userData.calc.bmi.adj20)) * 1000)/1000, 
        };
        
        this.saveCalculations({data:
        { current: Math.round(this.pcosRisk(this.userData.bmi > 40 ? 40 : (this.userData.bmi < 20?20:this.userData.bmi) ) * 10)/10, 
          adj5: Math.round(this.pcosRisk(this.userData.calc.bmi.adj5 > 40 ? 40 : (this.userData.calc.bmi.adj5 < 20?20:this.userData.calc.bmi.adj5)) * 10)/10, 
          adj10: Math.round(this.pcosRisk(this.userData.calc.bmi.adj10 > 40 ? 40 : (this.userData.calc.bmi.adj10 < 20?20: this.userData.calc.bmi.adj10)) * 10)/10, 
          adj15: Math.round(this.pcosRisk(this.userData.calc.bmi.adj15 > 40 ? 40 : (this.userData.calc.bmi.adj15 < 20?20: this.userData.calc.bmi.adj15)) * 10)/10, 
          adj20: Math.round(this.pcosRisk(this.userData.calc.bmi.adj20 > 40 ? 40 : (this.userData.calc.bmi.adj20 < 20?20: this.userData.calc.bmi.adj20)) * 10)/10, 
        }, section: 'pcos'});
        
        this.saveConfInt({data:
        { current: [Math.round(  (Math.max(0, (pcosCalc.current-(1.96*0.516979914)) ) ) *10)/10 , Math.round(   (pcosCalc.current+(1.96*0.516979914))   *10)/10], 
          adj5: [Math.round( (Math.max(0, (parseFloat(pcosCalc.adj5)-(1.96*0.516979914)) ) ) *10)/10, Math.round(  (pcosCalc.adj5+(1.96*0.516979914)) *10)/10], 
          adj10: [Math.round( (Math.max(0, (parseFloat(pcosCalc.adj10-(1.96*0.516979914)) )) ) *10)/10, Math.round(   (pcosCalc.adj10+(1.96*0.516979914) ) *10)/10], 
          adj15: [Math.round( (Math.max(0, (parseFloat(pcosCalc.adj15-(1.96*0.516979914))) ) ) *10)/10, Math.round(  (pcosCalc.adj15+(1.96*0.516979914) ) *10)/10],  
          adj20: [Math.round( (Math.max(0, (parseFloat(pcosCalc.adj20-(1.96*0.516979914))) ) ) *10)/10, Math.round(  (pcosCalc.adj20+(1.96*0.516979914) ) *10)/10], 
        }, section: 'pcos'});
        
        console.log('--------------------in calc manager: pcosCalc risk: '+ Math.round( (Math.max(0, (parseFloat(pcosCalc.adj15)-(1.96*0.516979914)) ) ) *10)/10 );
        console.log('pcosCalc risk: '+ (Math.max(0, (parseFloat(pcosCalc.adj15)-(1.96*0.516979914)) ) )  );
        // console.log('pcosCalc risk: '+ (Math.round( (pcosCalc.adj5+((1.96*0.516979914)*100)) ) ) );
        console.log('pcosCalc risk: '+ (parseFloat(pcosCalc.adj15)-(1.96*0.516979914)) );
        console.log('pcosCalc risk: '+((1.96*0.516979914)) );
        console.log('pcosCalc: '+(pcosCalc.adj15) );
        
        // NAFLD
         var nafldCalc =
        { current: (this.nafldRisk(this.userData.bmi > 40 ? 40 : (this.userData.bmi < 20?20:this.userData.bmi) ) * 100), 
          adj5: (this.nafldRisk(this.userData.calc.bmi.adj5 > 40 ? 40 : (this.userData.calc.bmi.adj5 < 20?20:this.userData.calc.bmi.adj5)) * 100), 
          adj10: (this.nafldRisk(this.userData.calc.bmi.adj10 > 40 ? 40 : (this.userData.calc.bmi.adj10 < 20?20: this.userData.calc.bmi.adj10)) * 100), 
        };
        
         this.saveCalculations({data:
        { current: Math.round(this.nafldRisk(this.userData.bmi > 40 ? 40 : (this.userData.bmi < 20?20:this.userData.bmi) ) * 100), 
          adj5: Math.round(this.nafldRisk(this.userData.calc.bmi.adj5 > 40 ? 40 : (this.userData.calc.bmi.adj5 < 20?20:this.userData.calc.bmi.adj5)) * 100), 
          adj10: Math.round(this.nafldRisk(this.userData.calc.bmi.adj10 > 40 ? 40 : (this.userData.calc.bmi.adj10 < 20?20: this.userData.calc.bmi.adj10)) * 100), 
        }, section: 'nafld'});
        
         this.saveConfInt({data:
        { current: [Math.round(  (Math.max(0, (nafldCalc.current-(1.96*0.001619385*100)) ) ) *10)/10 , Math.round(  (Math.min(1, ( (nafldCalc.current+(1.96*0.001619385*100))/100) ) ) *1000)/10], 
          adj5: [Math.round( (Math.max(0, (nafldCalc.adj5-(1.96*0.001619385*100)) ) ) *10)/10, Math.round(  (Math.min(1, (nafldCalc.adj5+(1.96*0.001619385*100))/100 ) ) *1000)/10], 
          adj10: [Math.round( (Math.max(0, (nafldCalc.adj10-(1.96*0.001619385*100)) ) ) *10)/10, Math.round(  (Math.min(1, (nafldCalc.adj10+(1.96*0.001619385*100))/100 ) ) *1000)/10], 
        }, section: 'nafld'});
        // console.log('in nafld risk calculator: '+JSON.stringify(this.userData.calc.nafld));
       
        
        //Diabetes - 
         var diabCalc =
        { current:  this.diabRisk(this.userData.bmi > 50 ? 50 : (this.userData.bmi < 20?20:this.userData.bmi) ) *100, 
          adj5:  this.diabRisk(this.userData.calc.bmi.adj5 > 50 ? 50 : (this.userData.calc.bmi.adj5 < 20?20:this.userData.calc.bmi.adj5)) *100, 
          adj10:  this.diabRisk(this.userData.calc.bmi.adj10 > 50 ? 50 : (this.userData.calc.bmi.adj10 < 20?20: this.userData.calc.bmi.adj10)) *100, 
          adj15:  this.diabRisk(this.userData.calc.bmi.adj15 > 50 ? 50 : (this.userData.calc.bmi.adj15 < 20?20: this.userData.calc.bmi.adj15)) *100,   
          adj20:  this.diabRisk(this.userData.calc.bmi.adj20 > 50 ? 50 : (this.userData.calc.bmi.adj20 < 20?20: this.userData.calc.bmi.adj20)) *100,  
        };
        
         this.saveCalculations({data:
        { current: Math.round(this.diabRisk(this.userData.bmi > 50 ? 50 : (this.userData.bmi < 20?20:this.userData.bmi) ) * 1000)/10, 
          adj5: Math.round(this.diabRisk(this.userData.calc.bmi.adj5 > 50 ? 50 : (this.userData.calc.bmi.adj5 < 20?20:this.userData.calc.bmi.adj5)) * 1000)/10, 
          adj10: Math.round(this.diabRisk(this.userData.calc.bmi.adj10 > 50 ? 50 : (this.userData.calc.bmi.adj10 < 20?20: this.userData.calc.bmi.adj10)) * 1000)/10, 
          adj15: Math.round(this.diabRisk(this.userData.calc.bmi.adj15 > 50 ? 50 : (this.userData.calc.bmi.adj15 < 20?20: this.userData.calc.bmi.adj15)) * 1000)/10,   
          adj20: Math.round(this.diabRisk(this.userData.calc.bmi.adj20 > 50 ? 50 : (this.userData.calc.bmi.adj20 < 20?20: this.userData.calc.bmi.adj20)) * 1000)/10,  
        }, section: 'diab'});
        
         this.saveConfInt({data:
        { current: [Math.round(  ( (diabCalc.current-(1.96*0.2098))  ) *10)/10 , Math.round(  ( ( (diabCalc.current+(1.96*0.2098/100))/100) ) *1000)/10], 
          adj5: [Math.round( ((diabCalc.adj5-(1.96*0.2098)) )  *10)/10, Math.round(  ( ((diabCalc.adj5+(1.96*0.2098/100))/100) ) *1000)/10], 
          adj10: [Math.round( ( (diabCalc.adj10-(1.96*0.2098))  ) *10)/10, Math.round(  (( (diabCalc.adj10+(1.96*0.2098/100))/100) ) *1000)/10], 
          adj15: [Math.round( ( (diabCalc.adj15-(1.96*0.2098)) ) *10)/10, Math.round(  ( ((diabCalc.adj15+(1.96*0.2098/100))/100) ) *1000)/10],  
          adj20: [Math.round( ( (diabCalc.adj20-(1.96*0.2098)) ) *10)/10, Math.round(  ( ((diabCalc.adj20+(1.96*0.2098/100))/100) ) *1000)/10], 
        }, section: 'diab'});
        // console.log('in diab risk: '+JSON.stringify(this.userData.calc.diab));
       
        
        //Osteoarthritis
         var oaCalc =
        { current: (this.oaRisk(this.userData.bmi > 50 ? 50 : (this.userData.bmi < 20?20:this.userData.bmi), this.userData.gender) ), 
          adj5:(this.oaRisk(this.userData.calc.bmi.adj5 > 50 ? 50 : (this.userData.calc.bmi.adj5 < 20?20:this.userData.calc.bmi.adj5), this.userData.gender) ), 
          adj10: (this.oaRisk(this.userData.calc.bmi.adj10 > 50 ? 50 : (this.userData.calc.bmi.adj10 < 20?20: this.userData.calc.bmi.adj10), this.userData.gender) ), 
          adj15: (this.oaRisk(this.userData.calc.bmi.adj15 > 50 ? 50 : (this.userData.calc.bmi.adj15 < 20?20: this.userData.calc.bmi.adj15), this.userData.gender) ), 
          adj20: (this.oaRisk(this.userData.calc.bmi.adj20 > 50 ? 50 : (this.userData.calc.bmi.adj20 < 20?20: this.userData.calc.bmi.adj20), this.userData.gender) ), 
        };
        
         this.saveCalculations({data:
        { current: Math.round(this.oaRisk(this.userData.bmi > 50 ? 50 : (this.userData.bmi < 20?20:this.userData.bmi), this.userData.gender) * 10)/10, 
          adj5: Math.round(this.oaRisk(this.userData.calc.bmi.adj5 > 50 ? 50 : (this.userData.calc.bmi.adj5 < 20?20:this.userData.calc.bmi.adj5), this.userData.gender) * 10)/10, 
          adj10: Math.round(this.oaRisk(this.userData.calc.bmi.adj10 > 50 ? 50 : (this.userData.calc.bmi.adj10 < 20?20: this.userData.calc.bmi.adj10), this.userData.gender) * 10)/10, 
          adj15: Math.round(this.oaRisk(this.userData.calc.bmi.adj15 > 50 ? 50 : (this.userData.calc.bmi.adj15 < 20?20: this.userData.calc.bmi.adj15), this.userData.gender) * 10)/10, 
          adj20: Math.round(this.oaRisk(this.userData.calc.bmi.adj20 > 50 ? 50 : (this.userData.calc.bmi.adj20 < 20?20: this.userData.calc.bmi.adj20), this.userData.gender) * 10)/10, 
        }, section: 'osteoarth'});
        
        this.saveConfInt({data:
        { current: [Math.round(  (  (oaCalc.current-(1.96*0.177833701))  ) *10)/10 , Math.round(   (oaCalc.current+(1.96*0.177833701))   *10)/10], 
          adj5: [Math.round( ( (oaCalc.adj5-(1.96*0.177833701))  ) *10)/10, Math.round(  (oaCalc.adj5+(1.96*0.177833701)) *10)/10], 
          adj10: [Math.round( ( (oaCalc.adj10-(1.96*0.177833701))  ) *10)/10, Math.round(   (oaCalc.adj10+(1.96*0.177833701) ) *10)/10], 
          adj15: [Math.round( ( (oaCalc.adj15-(1.96*0.177833701))  ) *10)/10, Math.round(  (oaCalc.adj15+(1.96*0.177833701) ) *10)/10],  
          adj20: [Math.round( ( (oaCalc.adj20-(1.96*0.177833701))  ) *10)/10, Math.round(  (oaCalc.adj20+(1.96*0.177833701) ) *10)/10], 
        }, section: 'osteoarth'});
        // console.log('in osteoarth ri sk: '+JSON.stringify(this.userData.calc.osteoarth));
         console.log('--------------------in calc manager: pcosCalc risk: '+ Math.round(  (oaCalc.adj5+(1.96*0.177833701)) *10)/10 );
        console.log('pcosCalc risk: '+ (oaCalc.adj5+(1.96*0.177833701))  );
        // console.log('pcosCalc risk: '+ (Math.round( (pcosCalc.adj5+((1.96*0.516979914)*100)) ) ) );
        // console.log('pcosCalc risk: '+ (parseFloat(pcosCalc.adj15)-(1.96*0.516979914)) );
        console.log('pcosCalc risk: '+((1.96*0.177833701)) );
        console.log('pcosCalc: '+(oaCalc.adj15) );
        
        // YLL
        var yllCalc = {
          current: [(this.getYll(this.userData.bmi))],
          adj5: [(this.getYll(this.userData.calc.bmi.adj5))],
          adj10: [(this.getYll(this.userData.calc.bmi.adj10))],
          adj15: [(this.getYll(this.userData.calc.bmi.adj15))],
          adj20: [(this.getYll(this.userData.calc.bmi.adj20))],
        };
        
        this.saveCalculations({
        data:{
          current: [Math.round(this.getYll(this.userData.bmi) *10)/10],
          adj5: [Math.round(this.getYll(this.userData.calc.bmi.adj5) *10)/10],
          adj10: [Math.round(this.getYll(this.userData.calc.bmi.adj10) *10)/10],
          adj15: [Math.round(this.getYll(this.userData.calc.bmi.adj15) *10)/10],
          adj20: [Math.round(this.getYll(this.userData.calc.bmi.adj20) *10)/10],
        }, section: 'yearsLost'});
        
         this.saveConfInt({data:
        { current: [Math.round(  ((yllCalc.current-(1.96*0.243255601)) ) *10)/10 , Math.round(  ((parseFloat(yllCalc.current)+(1.96*0.243255601)) ) *10)/10], 
          adj5: [Math.round( ( (yllCalc.adj5-(1.96*0.243255601))  ) *10)/10, Math.round(  (parseFloat(yllCalc.adj5)+(1.96*0.243255601)) *10)/10], 
          adj10: [Math.round( ((yllCalc.adj10-(1.96*0.243255601))  ) *10)/10, Math.round(   (parseFloat(yllCalc.adj10)+(1.96*0.243255601) ) *10)/10], 
          adj15: [Math.round( ((yllCalc.adj15-(1.96*0.243255601))  ) *10)/10, Math.round(  (parseFloat(yllCalc.adj15)+(1.96*0.243255601) ) *10)/10],  
          adj20: [Math.round( ((yllCalc.adj20-(1.96*0.243255601))  ) *10)/10, Math.round(  (parseFloat(yllCalc.adj20)+(1.96*0.243255601) ) *10)/10], 
        }, section: 'yearsLost'});
        // console.log("YLL: "+JSON.stringify(this.userData.calc.yearsLost));
        console.log('--------------------in calc manager: yll risk: '+  Math.round(  ((parseFloat(yllCalc.adj5)+(1.96*0.243255601)) ) *10)/10 );
        console.log('yllCalc risk: '+ (parseFloat(yllCalc.adj5)+(1.96*0.243255601)) );
        // console.log('yllCalc risk: '+(diabCalc.current-(1.96*0.243255601)) );
        console.log('yllCalc risk: '+((1.96*0.243255601)) );
        console.log('yllCalc: '+(yllCalc.adj5) );
        
        // reset adjust buttons selection
        this.userData.adjustButtons= {cancer: 0, hyplip: 0, hypten: 0, infertility: 0, nafld: 0, osteoarth: 0, diab: 0, yearsLost: 0};

      }
      else {
        this.saveCalculations({data:
        { current: '', adj5: '', adj10: '', adj15: '', adj20: '',
        }, section: 'cancer'});
        this.saveCalculations({data:
        { current: '', adj5: '', adj10: '', adj15: '', adj20: '',
        }, section: 'dyslip'});
        this.saveCalculations({data:
        { current: '', adj5: '', adj10: '', adj15: '', adj20: '',
        }, section: 'hypten'});
        this.saveCalculations({data:
        { current: '', adj5: '', adj10: '', adj15: '', adj20: '',
        }, section: 'pcos'});
        this.saveCalculations({data:
        { current: '', adj5: '', adj10: '',
        }, section: 'nafld'});
        this.saveCalculations({data:
        { current: '', adj5: '', adj10: '', adj15: '', adj20: '',
        }, section: 'osteoarth'});
        this.saveCalculations({data:
        { current: '', adj5: '', adj10: '', adj15: '', adj20: '',
        }, section: 'diab'});
      }

    },

  }
};
